import React from "react";
import { connect } from "react-redux";
import Loader from "../../../../components/Loader";
import {
  fetchUsers,
  updateRole,
  deleteUser
} from "../../../../modules/user/actions";

import { sendEmailTa } from "../../../../modules/emails/actions";
import UserList from "../UserList/component";

class UserListContainer extends React.Component {
  componentWillMount() {
    this.props.fetchUsers();
  }

  render() {
    const { loading, users } = this.props;
    if (loading) {
      return <Loader />;
    }
    return (
      <UserList
        users={users}
        sendEmail={this.props.sendEmailTa}
        updateRole={this.props.updateRole}
        deleteUser={this.props.deleteUser}
        language={this.props.language}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.preference.language,
    users: state.user.users,
    loading: state.user.loading
  };
}

const mapActionsToProps = {
  fetchUsers,
  sendEmailTa,
  updateRole,
  deleteUser
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(UserListContainer);



// WEBPACK FOOTER //
// ./src/pages/Admin/UsersCollection/UserList/container.js